import styled from "styled-components";

export const Edge = styled.path``;
